module.exports = __webpack_public_path__ + "static/media/cable.d5536dbd.JPG";